var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.downloadPath,"download":_vm.name},domProps:{"textContent":_vm._s(_vm.name)}})
}
var staticRenderFns = []

export { render, staticRenderFns }